import React from 'react';
import PropTypes from 'prop-types';
import bellIcon from '../../../assets/images/bell-icon.svg';
function ReviewAlert(_ref) {
  var numberOfReviews = _ref.numberOfReviews;
  return /*#__PURE__*/React.createElement("a", {
    id: "review-employer-alert",
    className: "card-multi box-shadow-1 mb-3 g-row--always g-row--between",
    href: "reviews"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reviews-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: bellIcon,
    alt: "review-alert-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "details-multi"
  }, /*#__PURE__*/React.createElement("strong", null, numberOfReviews), ' ', "consultant reviews pending")), /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-right"
  })));
}
ReviewAlert.propTypes = {
  numberOfReviews: PropTypes.number
};
ReviewAlert.defaultProps = {
  numberOfReviews: 1
};
export default ReviewAlert;